import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";

import { ServiceType } from "models/setup/service-type";
import { Service } from "models/setup/service";
import { ServiceFilterParam } from "models/setup/service-filter-param";
import { BaseSearchParam } from "models/base-search-param";

import { VehicleModelImportParam } from 'models/setup/vehicle-model-import-param';
import { Manufacturer, VehicleModel } from 'models/vehicle/vehicle-model';
import { Tax } from "models/tax/tax";
import { Product } from "models/setup/product"
import { ProductFilterParam } from "models/setup/product-filter-param";
import { Promotion } from "models/promotion/promotion"
import { PromotionFilterParam } from "models/promotion/promotion-filter-param"


export async function CreateServiceType(param: ServiceType): Promise<APIResult<ServiceType>> {
    return await WebAPIClient.postData<ServiceType>(ApiEndPoints.service_types_create, param);
}
export async function UpdateServiceType(param: ServiceType): Promise<APIResult<ServiceType>> {
    return await WebAPIClient.putData<ServiceType>(ApiEndPoints.service_types_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetServiceTypes(): Promise<APIResult<ServiceType[]>> {
    return await WebAPIClient.getData<ServiceType[]>(ApiEndPoints.service_types_search);
}

export async function CreateService(param: Service): Promise<APIResult<Service>> {
    return await WebAPIClient.postData<Service>(ApiEndPoints.service_create, param);
}
export async function UpdateService(param: Service): Promise<APIResult<Service>> {
    return await WebAPIClient.putData<Service>(ApiEndPoints.service_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetServices(param: ServiceFilterParam): Promise<APIResult<Service[]>> {
    const searchParams = new BaseSearchParam(param);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.service_search}${queryString}`;

    return await WebAPIClient.getData<Service[]>(apiUrl);
}

//Vehicle model import

export async function VehicleModelImport(param: VehicleModelImportParam): Promise<APIResult<VehicleModel[]>> {
    return await WebAPIClient.postData<VehicleModel[]>(ApiEndPoints.vehicle_model_import, param);
}


//Tax
export async function GetTaxes(): Promise<APIResult<Tax[]>> {
    return await WebAPIClient.getData<Tax[]>(ApiEndPoints.tax_search);
}

//Products
export async function CreateProduct(param: Product): Promise<APIResult<Product>> {
    return await WebAPIClient.postData<Product>(ApiEndPoints.product_create, param);
}
export async function UpdateProduct(param: Product): Promise<APIResult<Product>> {
    return await WebAPIClient.putData<Product>(ApiEndPoints.product_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetProducts(param: ProductFilterParam): Promise<APIResult<Product[]>> {
    const searchParams = new BaseSearchParam(param);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.product_search}${queryString}`;
    return await WebAPIClient.getData<Product[]>(apiUrl);
}

//Promotions
export async function CreatePromotion(param: Promotion): Promise<APIResult<Promotion>> {
    return await WebAPIClient.postData<Promotion>(ApiEndPoints.promotion_create, param);
}
export async function UpdatePromotion(param: Promotion): Promise<APIResult<Promotion>> {
    return await WebAPIClient.putData<Promotion>(ApiEndPoints.promotion_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetPromotions(param: PromotionFilterParam): Promise<APIResult<Promotion[]>> {
    const searchParams = new BaseSearchParam(param);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.promotion_search}${queryString}`;
    return await WebAPIClient.getData<Promotion[]>(apiUrl);
}